// The return value decides whether the payload becomes the base for later
// merges, so an absent API reports false rather than a push that never happened.
export function pushSituationalAwareness(agentEl, context) {
  if (!agentEl.setSituationalAwareness) return false;
  try {
    agentEl.setSituationalAwareness(context);
    return true;
  } catch (e) {
    // Callers measure against the limit first, so reaching this means the
    // vendor changed it - the SDK bundle is loaded unversioned.
    console.error('Mindset: situational awareness push rejected', e);
    return false;
  }
}